export class DateHelper {
  public static getMinDate(): Date {
    return new Date(1900, 1, 11);
  }

  public static getLocalDateAsString(): string {
    const add0 = (val: number) => {
      const stringVal = val.toString();
      return stringVal.length < 2 ? '0' + val : val;
    };

    const d = new Date();
    const month = add0(d.getMonth() + 1);
    const day = add0(d.getDate());
    const year = d.getFullYear();
    const hour = add0(d.getHours());
    const minute = add0(d.getMinutes());
    const second = add0(d.getSeconds());

    return `${[year, month, day].join('-')}T${[hour, minute, second].join(':')}`;
  }

  public static formatLocalDateString(localDate: string): string {
    return localDate.replace('T', ' ');
  }

  public static getCustomLocalDate(rawTime: string): string {
    return `${rawTime.slice(8, 10)}/${rawTime.slice(5, 7)}/${rawTime.slice(0, 4)} ${rawTime.slice(11, 16)}`;
  }

  public static getLocalDateByDMY(date: string): string {
    const localDate = new Date(date).toLocaleString('en-GB', {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
    });
    return localDate;
  }

  public static getLocalDateByDmYHM(date: string): string {
    const localDate = new Date(date).toLocaleString('en-GB', {
      minute: 'numeric',
      hour: 'numeric',
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
    });
    return localDate;
  }

  public static getLocalDateByHM(date: string): string {
    const localDate = new Date(date).toLocaleString('en-GB', {
      minute: 'numeric',
      hour: 'numeric',
    });
    return localDate;
  }
  public static extractTime(date: string): string {
    const isUTC = date.endsWith('Z'); // Check if the input ends with 'Z' (indicating UTC)
    const parsedDate = new Date(date); // Parse the date
    const hours = isUTC
      ? parsedDate
          .getUTCHours()
          .toString()
          .padStart(2, '0') // Use UTC hours if input is UTC
      : parsedDate
          .getHours()
          .toString()
          .padStart(2, '0'); // Use local hours if not UTC
    const minutes = isUTC
      ? parsedDate
          .getUTCMinutes()
          .toString()
          .padStart(2, '0') // Use UTC minutes
      : parsedDate
          .getMinutes()
          .toString()
          .padStart(2, '0'); // Use local minutes
    return `${hours}:${minutes}`; // Return the time in HH:MM format
  }

  public static subtractDays(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(date.getDate() - days);
    return result;
  }

  public static subtractMonths(date: Date, months: number): Date {
    const result = new Date(date);
    result.setMonth(date.getMonth() - months);
    return result;
  }

  public static formatDateToYYYYMMDD(date: Date): string {
    const add0 = (val: number) => {
      const stringVal = val.toString();
      return stringVal.length < 2 ? '0' + val : val;
    };

    const month = add0(date.getMonth() + 1);
    const day = add0(date.getDate());
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
  }

  public static formatDateToDDMMYYYY(date: Date): string {
    const add0 = (val: number) => {
      const stringVal = val.toString();
      return stringVal.length < 2 ? '0' + val : val;
    };

    const month = add0(date.getMonth() + 1);
    const day = add0(date.getDate());
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  public static formatDateToYYYYMMDDWithTime(date: Date): string {
    const add0 = (val: number) => {
      const stringVal = val.toString();
      return stringVal.length < 2 ? '0' + val : val;
    };

    const month = add0(date.getMonth() + 1);
    const day = add0(date.getDate());
    const year = date.getFullYear();
    const hour = add0(date.getHours());
    const minute = add0(date.getMinutes());
    const second = add0(date.getSeconds());

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  }

  public static getJulianDateToday() {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 1);
    const diff = now.getTime() - start.getTime();
    const oneDay = 1000 * 60 * 60 * 24;
    const day = Math.floor(diff / oneDay) + 1;

    return `${now
      .getFullYear()
      .toString()
      .slice(-2)}${day.toString().padStart(3, '0')}`;
  }

  public static formatTimeSlotDateTime(dateStr: string): string {
    const date = new Date(dateStr);
    const add0 = (val: number) => {
      const stringVal = val.toString();
      return stringVal.length < 2 ? '0' + val : val;
    };

    const month = add0(date.getMonth() + 1);
    const day = add0(date.getDate());
    const year = date.getFullYear();

    const hours = add0(date.getHours());
    const minutes = add0(date.getMinutes());
    const seconds = add0(date.getSeconds());

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }
}
